const manageSpacecraft = {
    manage: {
        pageTitle: 'Manage Spacecraft',
        pageDescription: 'Check and access to the registered spacecraft',
        grid: {
            name: 'Name',
            noradId: 'Norad ID',
            tleTitle: 'TLE - Title Line',
            direction: 'Direction',
            band: 'Band',
            centerFrequency: 'Center Frequency',
            registeredAt: 'Registered At',
            tleUpdate: 'TLE Update',
            viewDetails: 'View Details',
            update: 'Update'
        },
        button: {
            searchPlaceholder: 'Search',
            delete: 'Delete',
            add: 'Add Spacecraft',
            viewDetails: 'View Details',
            update: 'Update',
            cancel: 'Cancel',
            next: 'next',
            getTle: 'Get TLE',
            previous: 'Previous',
            done: 'Done',
            save: 'Save',
            edit: 'Edit'
        },
        message: {
            tleUpdated: 'TLE has been updated.'
        },
        modal: {
            title: 'Add Spacecraft',
            name: 'Name',
            noradId: 'NORAD ID',
            tleTitle: 'TLE - Title',
            tleLine1: 'TLE - Line 1',
            tleLine2: 'TLE - Line 2',
            direction: 'Direction',
            band: 'Band',
            centerFrequency: 'Center Frequency (MHz)',
            modulation: 'Modulation',
            bitRate: 'Bit Rate',
            polarization: 'Polarization',
            convolutionalCode: 'Convolutional Code or Derandomization',
            reedsolomonCode: 'Reed-Solomon Code (FEC)',
            subFrequency: 'Subcarrier Frequency',
            pcmCoding: 'PCM Coding',
            frameSyncWord: 'Sync Word',
            frameSize: 'Frame Size',
            syn: 'SYN',
            ctl: 'CTL',
            lts: 'LTS',
            slip: 'SLIP',
            other: '(Optional) Other',
            directionId: 'Direction ID',
            bandId: 'Band ID',
            modulationId: 'Modulation ID',
            polarizationId: 'Polarization ID',
            convCodeId: 'Conv. Code ID',
            rsCodeId: 'RS Code ID',
            convCode: 'Convolutional Code',
            rsCode: 'Reed-Solomon Code',
            pcmCodingId: 'PCM Coding ID',
            randomization: 'Randomization',
            randomizationId: 'Randomization ID',
            syncStrategy: 'Sync Strategy',
            detail: {
                name: 'Name',
                noradId: 'NORAD ID',
                tleTitle: 'TLE - Title',
                tleLine1: 'TLE - Line 1',
                tleLine2: 'TLE - Line 2',
                direction: 'Direction',
                band: 'Band',
                centerFrequency: 'Center Frequency',
                modulationName: 'Modulation',
                bitRate: 'Bit Rate',
                polarizationName: 'Polarization',
                convolutionalCodeName: 'Convolutional Code',
                rsCodeName: 'Reed-Solomon Code',
                subFrequency: 'Subcarrier Frequency',
                pcmCodingName: 'PCM Coding',
                frameSyncWord: 'Sync Word',
                frameSize: 'Frame Size',
                syn: 'SYN',
                ctl: 'CTL',
                lts: 'LTS',
                slip: 'SLIP',
                other: 'Other'
            },
            deleteTitle: 'Delete',
            deleteMessage: 'Are you sure you want to delete it? This operation cannot be undone.'
        },
        tab: {
            downlink: 'Downlink',
            uplink: 'Uplink',
            sband: 'S-Band',
            xband: 'X-Band'
        },
        tooltip: {
            name: 'This is the name used when searching for a schedule.',
            noradId: "It automatically fills in when you click 'Get TLE' or press Enter.",
            centerFrequency: 'Tx : 2025 ~ 2120  Rx : 2200 ~ 2300',
            bitRate: 'Min : 1,000 bps / Max : 40,000,000 bps',
            subFrequency: 'High bandwidth with sub-carrier',
            frameSyncWord: 'Base: 0x1ACFFC1D (32bit, 4byte)',
            syncStrategy: 'Synchronization strategy using SYN/CTL/LTS/SLIP',
        },
        placeholder: {
            noradId: "It automatically fills in when you click 'Get TLE' or press Enter.",
            centerFrequency: 'Tx : 2025 ~ 2120  Rx : 2200 ~ 2300',
            bitRate: 'Min: 1,000 bps   Max: 40,000,000 bps',
            subFrequency: '0 to 2,000,000 (in Hz)',
        },

    }
};

export default manageSpacecraft;
